import React, {PropTypes, Component} from 'react';
import {Link} from 'react-router';
import utils from '../../../utils/utils';

export default class SingleTag extends Component {

  render() {
    const {path, label, size} = this.props;
    return (
      <Link data-hook="single-tag" style={size !== 'undefined' ? {fontSize: `${size}px`} : {}} to={path} onClick={() => utils.reportBi('334', `button_name=${label.replace(',', '').toLowerCase()}&location=article`)}>{label}</Link>
    );
  }
}

SingleTag.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.string
};




// WEBPACK FOOTER //
// ./components/partial/SingleTag/SingleTag.js